module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tooltip) ? _c('el-tooltip', {
    attrs: {
      "effect": "dark",
      "content": _vm.buttonLabel || _vm.label,
      "enterable": false,
      "placement": _vm.placement
    }
  }, [_c('button', {
    staticClass: "btn",
    class: ['btn-' + _vm.type, 'btn-' + _vm.size],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.loading
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "iconfont icon-loading"
  })]) : (_vm.icon) ? _c('span', [_c('i', {
    class: ['iconfont', 'icon-' + _vm.icon]
  })]) : _vm._e()])]) : _c('button', {
    staticClass: "btn",
    class: ['btn-' + _vm.type, 'btn-' + _vm.size],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.loading
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "btn-icon"
  }, [_c('i', {
    staticClass: "iconfont icon-loading"
  })]) : (_vm.icon) ? _c('span', {
    staticClass: "btn-icon"
  }, [_c('i', {
    class: ['iconfont', 'icon-' + _vm.icon]
  })]) : _vm._e(), _vm._v(_vm._s(_vm.buttonLabel || _vm.label))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bf0b62b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtonList/ButtonItem.vue
// module id = 1771
// module chunks = 1